import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import '../../../../styles/RegDashboard.css';
import { HHIEButton } from '../../../utility/HHIEButton';

export function AccountRegistrationModal(props) {
    const [accountIsFullyRegistered, setAccountIsFullyRegistered] = useState();

    useEffect(() => {
        setAccountIsFullyRegistered(props.accountIsFullyRegistered)
    }, []);

    return (
        <Modal
            show={!accountIsFullyRegistered}
            size="lg"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Complete Account Registration
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    In order to continue using this system, you must fill out any required vital information. Click the button below to do so.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <HHIEButton
                    id="complete-acct-reg-btn"
                    title="complete-acct-reg-btn"
                    title="Complete Account Registration"
                    onClick={
                        () => {
                            window.location.href = '/account-form'
                        }
                    }
                />
            </Modal.Footer>
        </Modal>
    );
}
